import React from 'react';
export function Footer() {
  return <footer className="bg-brand-footer py-10 px-6 text-center" data-id="element-10">
      <p className="text-white/40 text-sm font-medium" data-id="element-11">
        © 2026 · Alimentación Natural para tu Mascota · Todos los derechos
        reservados
      </p>
    </footer>;
}